export enum StatusClassificacaoEnum {
    PRETENDIDA = 1,
    ATRIBUIDA = 2,
    PRETENDIDA_RECONSIDERACAO = 3,
    ATRIBUIDA_RECONSIDERACAO = 4,
    ATRIBUIDA_RECURSO = 5,
    PRETENDIDA_RECURSO = 6,
}
